module.exports = __webpack_public_path__ + "img/rapa-nui.2dfa38a9.png";